import { render } from "./TabsComponent.vue?vue&type=template&id=2b5c4394&scoped=true"
import script from "./TabsComponent.vue?vue&type=script&lang=js"
export * from "./TabsComponent.vue?vue&type=script&lang=js"

import "./TabsComponent.vue?vue&type=style&index=0&id=2b5c4394&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5c4394"]])

export default __exports__